module.exports = __webpack_public_path__ + "static/media/imagotipo-finmas.29cd98a1.svg";